module.exports = __webpack_public_path__ + "media/images/emblems/Rottenschwil-blason-eab3cbb265ffa853379d1d481321db94.png";